<script>
    export default {
      name: 'lote-imagens',
      props: ['lote', 'video'],
      data () {
        return {
          loteAtual: null,
          url: null,
          imagem: null,
          imagemIndex: 0,
          imagens: []
        }
      },
      watch: {
        lote () {
          this.montaAnimacao()
        }
      },
      mounted () {
      },
      destroyed () {
      },
      methods: {
        montaAnimacao () {
          let lote = this.lote
          if (this.loteAtual === lote.id) {
            return
          }
          let url = lote.imagem.split('/')
          url.splice(-1, 1)
          url = url.join('/') + '/'
          this.url = url
          this.imagens = []
          lote.fotos.forEach((foto) => {
            this.imagens.push(url + foto.arquivo)
          })
          this.imagem = this.imagens[0]
          window.clearInterval(this.$interval)
          this.$interval = setInterval(() => {
            this.imagemIndex++
            if (typeof this.imagens[this.imagemIndex] === 'undefined') {
              this.imagemIndex = 0
            }
            this.imagem = this.imagens[this.imagemIndex]
          }, 2000)
        },
        onEnd: function () {
          this.$emit('videoEnded')
        }
      },
      components: {}
    }
</script>

<template>
  <div class="image" :class="'lote-img-status' + lote.status">
    <video @ended="onEnd" v-if="video !== null" autoplay>
      <source :src="video" type="video/mp4">
    </video>
    <img :class="video !== null ? 'hide' : ''" ref="imagem" :src="imagem">
  </div>
</template>



// WEBPACK FOOTER //
// lote-imagens.vue?440d215a